// extracted by mini-css-extract-plugin
var _1 = "HomeworkIcon__academy--Iog3W";
var _2 = "HomeworkIcon__assigned--CA53k";
var _3 = "HomeworkIcon__clickable--p_tTl";
var _4 = "HomeworkIcon__hoverTextLarge--IVUzw HomeworkIcon__iconLarge--lvVNk";
var _5 = "HomeworkIcon__hoverTextSmall--jWc4Z HomeworkIcon__iconSmall--BG9mP";
var _6 = "HomeworkIcon__hwIconFill--HN_JJ";
var _7 = "HomeworkIcon__iconLarge--lvVNk";
var _8 = "HomeworkIcon__iconSmall--BG9mP";
var _9 = "HomeworkIcon__main--wOChP";
var _a = "HomeworkIcon__mainDisabled--STp0F";
var _b = "HomeworkIcon__mainHidden--GYztu HomeworkIcon__main--wOChP";
var _c = "HomeworkIcon__svgLarge--ckF_2 HomeworkIcon__iconLarge--lvVNk";
var _d = "HomeworkIcon__svgSmall--UeWax HomeworkIcon__iconSmall--BG9mP";
var _e = "HomeworkIcon__unreleased--W_bEw";
export { _1 as "academy", _2 as "assigned", _3 as "clickable", _4 as "hoverTextLarge", _5 as "hoverTextSmall", _6 as "hwIconFill", _7 as "iconLarge", _8 as "iconSmall", _9 as "main", _a as "mainDisabled", _b as "mainHidden", _c as "svgLarge", _d as "svgSmall", _e as "unreleased" }
